import { FEATURE_FLAGS } from '@/constants/feature-flags';
import { cva } from 'class-variance-authority';

const isV2 = FEATURE_FLAGS.ENABLE_SCORECARD_V2;

/**
 * Base styles for the scorecard component
 */
export const scorecardStyles = cva(
  ['bg-neutral-white', 'rounded-lg', 'flex', 'flex-col', 'w-full'].join(' '),
  {
    variants: {
      size: {
        compact: 'p-6 gap-1 max-w-xs',
        standard: 'p-6 gap-2 max-w-md',
        expanded: 'p-8 gap-3 max-w-lg',
      },
      variant: {
        default: '',
        highlighted: 'ring-2 ring-brand-primary-300 shadow-lg',
        subtle: 'border border-neutral-gray-100 shadow-none',
        simple: 'border border-neutral-gray-500 shadow-none',
        violation: isV2
          ? 'bg-accent-surface-yellow border border-accent-border-yellow shadow-none'
          : 'bg-accent-surface-red border border-accent-red-500 shadow-none',
        pass: 'bg-accent-surface-green border border-accent-green-500 shadow-none',
        fail: isV2
          ? 'bg-accent-surface-yellow border border-accent-border-yellow shadow-none'
          : 'bg-accent-surface-red border border-accent-red-500 shadow-none',
      },
    },
    defaultVariants: {
      size: 'standard',
      variant: 'default',
    },
    compoundVariants: [
      {
        variant: 'simple',
        className: ['gap-1', 'py-4 px-5', 'w-auto', 'max-w-fit', 'items-center'],
      },
      {
        variant: ['violation', 'pass', 'fail'],
        className: [
          'gap-1',
          'py-4 px-5',
          'h-20 min-h-20 max-h-20',
          'w-20 min-w-20 max-w-20',
          'items-center',
          'justify-center',
        ],
      },
    ],
  },
);

/**
 * Styles for the score display text
 */
export const scoreDisplayStyles = cva('', {
  variants: {
    size: {
      compact: 'text-7xl text-neutral-black font-bold font-display leading-none',
      standard: 'text-7xl text-neutral-black font-bold font-display leading-none',
      large: 'text-7xl text-neutral-black font-bold font-display leading-none',
      simple: 'text-xl font-display font-bold leading-tight text-neutral-black',
    },
  },
  defaultVariants: {
    size: 'standard',
  },
});

/**
 * Styles for the action buttons container
 */
export const actionsContainerStyles = cva('flex', {
  variants: {
    layout: {
      horizontal: [
        'gap-4 2xl:gap-2 3xl:gap-4',
        'flex-row 2xl:flex-col 3xl:flex-row',
        'items-center 2xl:items-start 3xl:items-center',
      ],
      vertical: 'gap-2 flex-col items-stretch',
      stacked: 'gap-2 flex-col items-start',
    },
    size: {
      compact: 'justify-start',
      standard: 'justify-start',
      expanded: 'justify-start',
    },
  },
  defaultVariants: {
    layout: 'horizontal',
    size: 'standard',
  },
  compoundVariants: [
    {
      layout: 'horizontal',
      size: 'compact',
      className: 'flex-row 2xl:flex-row 3xl:flex-row',
    },
  ],
});
